// manage ui state
// darkmode
// sidebar
import { defineStore, storeToRefs } from "pinia";
import { ref } from "vue";

export const useUIStore = defineStore(
    "ui",
    () => {
        const darkMode = ref<boolean>(false);
        const showSidebar = ref<boolean>(true);
        const sidebarWidth = ref<number>(180);
        // Width of the right-hand History panel (resizable, persisted).
        const historyWidth = ref<number>(320);
        // Wording register on the reconcile page: plain language ("Keep main")
        // vs technical ("Take main (theirs)", branch refs, conflict kinds).
        const reconcileWording = ref<"plain" | "technical">("plain");
        // The most recently visited stek, kept even once you navigate away to
        // a stek-less page (Settings, Platform Admin, Activity Metrics — see
        // route meta `outsideMode`) — lets the rail's mode switcher and the
        // top bar's home link still take you somewhere on those pages,
        // instead of going dead for lack of a stek in the current route.
        const lastStek = ref<{ orgName: string; stekName: string }>();

        const toggleDarkMode = (newValue?: boolean) => {
            if (newValue === undefined) {
                newValue = !darkMode.value;
            }
            if (newValue) {
                document
                    .querySelector("html")!
                    .classList.add("dark-mode", "sl-theme-dark");
            } else {
                document
                    .querySelector("html")!
                    .classList.remove("dark-mode", "sl-theme-dark");
            }
            darkMode.value = newValue;
        };

        const toggleSideBar = () => {
            showSidebar.value = !showSidebar.value;
        };

        return {
            darkMode,
            toggleDarkMode,
            showSidebar,
            sidebarWidth,
            historyWidth,
            reconcileWording,
            lastStek,
            toggleSideBar,
        };
    },
    {
        // persist this store in localStorage
        persist: {
            storage: localStorage,
            afterHydrate: (ctx) => {
                if (ctx.store.darkMode === true) {
                    ctx.store.toggleDarkMode(true);
                }
            },
        },
    }
);

export const useUIManager = () => storeToRefs(useUIStore());
